import { coursesColl } from "./courses.constants";

export function useCourses(){
    return{
        coursesColl
    }
}